import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCartItems, setMyCartModalVisibility } from "../../store/actions";
import { useNavigate } from "react-router-dom";

export function ProductCard({ element, prevProduct, nextProduct, allProducts }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cartItems);
  const myCartModalVisibility = useSelector((state) => state.myCartModalVisibility);
  const file_url = "/media/" + element.product_slug + element.cover_image;
  const product_image_url = `url('${file_url}')`;
  let badge_class = "badge badge-circle ml-auto w-45px h-45px fs-12 d-flex align-items-center justify-content-center mb-2";
  let badge = {
    type: element.product_badge,
    class: "",
    show: false,
  };
  switch (element.product_badge) {
    case "new":
      badge.class = badge_class + " badge-green";
      badge.show = true;
      break;
    case "sale":
      badge.class = badge_class + " badge-danger";
      badge.show = true;
      break;
    case "hot":
      badge.class = badge_class + " badge-yellow";
      badge.show = true;
      break;
    default:
  }

  const original_price = element.product_price;
  const discount = element.product_discount;
  if (discount > 0) {
    badge.class = badge_class + " badge-danger";
    badge.show = true;
    badge.type = "-" + discount + "%";
  }
  const new_price = Number(original_price - (discount * original_price) / 100).toFixed(2);
  const price_with_discount = discount ? new_price : original_price;

  function btnAddToCart(e, element) {
    // Check if the product is already in the cart
    const product = cartItems.find((x) => x.product_id === element.product_id);
    // If the product don't exist in the cart, add it
    if (!product) {
      element.product_quantity = 1;
      dispatch(setCartItems([...cartItems, element]));
      // Show My Cart Sidebar

      dispatch(setMyCartModalVisibility(!myCartModalVisibility));
    } else {
      // if the product exist in the cart, remove it
      dispatch(setCartItems(cartItems.filter((x) => x.product_id !== element.product_id)));
    }
  }

  const circleBtnClasses = "d-flex align-items-center justify-content-center text-primary hover-white bg-hover-primary w-45px h-45px rounded-circle mb-2 border";
  // Check if the product is already in the cart
  const product = cartItems.find((x) => x.product_id === element.product_id);
  let btnAddToCartClass = "add-to-cart " + circleBtnClasses;
  if (!product) {
    btnAddToCartClass += " bg-white";
  } else {
    btnAddToCartClass += " bg-danger";
  }

  const product_link = "/product/" + element.product_slug;
  const titleColor = element.title_color;
  const subtitleColor = element.subtitle_color;
  const priceColor = element.price_color;
  const handlePreviewClick = () => {
    navigate(product_link, { state: { allProducts } });
  };
  
  return (
    <>
      <div className="grid-item">
        <div className="card border-0 hover-change-content product">
          <div
            style={{
              backgroundImage: product_image_url,
            }}
            className="card-img ratio bg-img-cover-center ratio-1-1"
          ></div>
          <div className="card-img-overlay d-flex py-4 py-sm-5 pl-6 pr-4">
            <div className="d-flex flex-column">
              <a href={product_link} class="font-weight-bold mb-1 d-block lh-12" style={{ color: titleColor }}>{element.product_name}</a>
              <a class="text-uppercase text-muted letter-spacing-05 fs-13 font-weight-500" style={{ color: subtitleColor }}>{element.category}</a>
              <p class="mt-auto mb-0 font-weight-500" style={{ color: priceColor }}>{original_price.toFixed(2)} EUR</p>
            </div>
            <div className="ml-auto d-flex flex-column">
              <div className="my-auto content-change-vertical">
                {badge.show && <div className={badge.class}>{badge.type}</div>}
                {/* Add to Card Button */}
                <button
                  onClick={(e) => {
                    btnAddToCart(e, element);
                  }}
                  data-toggle="tooltip"
                  data-placement="left"
                  title="In den Warenkorb"
                  className={btnAddToCartClass}
                >
                  <i className="far fa-shopping-basket"></i>
                </button>
                {/* Add to Wishlist Button */}
                <button
                  onClick={handlePreviewClick}
                  data-toggle="tooltip"
                  data-placement="left"
                  title="Preview"
                  className="preview d-flex align-items-center justify-content-center text-primary bg-white hover-white bg-hover-primary w-45px h-45px rounded-circle mb-2 border"
                >
                  <i className="far fa-eye"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProductCard;
